module.exports = __webpack_public_path__ + "img/logo_gepa.072e61d5.svg";